import { render, staticRenderFns } from "./TableOnlyQuery.vue?vue&type=template&id=69650d47&scoped=true&"
import script from "./TableOnlyQuery.vue?vue&type=script&lang=js&"
export * from "./TableOnlyQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69650d47",
  null
  
)

export default component.exports